import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../core';
import { LoggerService } from '../logger';
import { UserService } from '../user';

@Injectable({
    providedIn: 'root'
})
export class GTMService {

    constructor(private logger: LoggerService, @Inject(WINDOW) private window: Window & { dataLayer: any }, private userService: UserService) { }

    load() {

        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            });
            const f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            (j as any).async = true;
            (j as any).src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-N7JRV8W');

        const body = this.window.document.getElementsByTagName('body')[0];
        const noscript_gtm = this.window.document.createElement('noscript');
        const iframe_gtm = this.window.document.createElement('iframe');

        iframe_gtm.src = 'https://www.googletagmanager.com/ns.html?id=GTM-N7JRV8W';
        //@ts-ignore
        iframe_gtm.style = "display:none;visibility:hidden";
        iframe_gtm.height = "0";
        iframe_gtm.width = "0";

        noscript_gtm.appendChild(iframe_gtm);
        body.appendChild(noscript_gtm);

    }

    unload() {
        this.window.dataLayer = {
            push: function () {
                return null;
            },
            slice: function () {
                return null;
            }
        }
    }

    push(eventName) {
        this.userService.get().then(user => {
            this.load();
            if (this.window.dataLayer && user && user.id) {
                (window as any).dataLayer.push({
                    'event': eventName,
                    'user_id': user.id,
                    'tm_id': user.id
                });
            } else {
                this.logger.info("GTMService: not loaded");
            }
        }).catch(error => {
            this.logger.error('GTMService: Error getting user for GTM', error);
        });

        setTimeout(() => {
            this.unload();
        }, 3000)
    }
}